import { Canvas } from "@react-three/fiber";
import {
  OrbitControls,
  Environment,
  ContactShadows,
  Float,
} from "@react-three/drei";
import { Suspense, useState } from "react";

import { ModelViewer } from "./ModelViewer";
import { SceneLights } from "./SceneLights";
import { CameraIntro } from "./CameraIntro";
import ModelLoader from "./ModelLaoder";

/* =========================
   PROPS TYPE (IMPORTANT)
========================= */
export interface ProductCanvasProps {
  parts: {
    base: string;
    partA: string;
    partB: string;
    orings: string;
  };
  activeParts: string[];
  activeColors: {
    AB: string;
    ORINGS: string;
  };
  rotateMode: boolean;
}

/* =========================
   COMPONENT
========================= */
const ProductCanvas: React.FC<ProductCanvasProps> = ({
  parts,
  activeParts,
  activeColors,
  rotateMode,
}) => {
  const [sceneReady, setSceneReady] = useState(false);
const isMobile =
  typeof window !== "undefined" &&
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
   <Canvas
  camera={{ fov: 45 }}
  style={{
    /* ✅ Desktop: untouched */
    /* ✅ Mobile: toggle behavior */
    touchAction: isMobile
      ? rotateMode
        ? "none"   // block page scroll while rotating
        : "auto"   // allow page scroll
      : "auto",

    pointerEvents: isMobile
      ? rotateMode
        ? "auto"   // allow rotation
        : "none"   // ignore touches so page scroll works
      : "auto",   // 👈 desktop always interactive
  }}
>

      <Suspense fallback={<ModelLoader />}>
        <CameraIntro />
        <SceneLights />
        <Environment preset="studio" />

        <Float
          speed={1.2}
          rotationIntensity={sceneReady ? 0.15 : 0}
          floatIntensity={sceneReady ? 0.25 : 0}
        >
          <ModelViewer
            parts={parts}
            activeParts={activeParts}
            activeColors={activeColors}
            onReady={() => setSceneReady(true)}
          />
        </Float>

        <ContactShadows
          position={[0, -1.4, 0]}
          opacity={0.35}
          scale={10}
          blur={2.5}
          far={4}
        />

       <OrbitControls
  enabled={isMobile ? rotateMode : true} // 👈 KEY LINE
  enableZoom={false}
  enablePan={false}
  enableDamping
  dampingFactor={0.08}
  rotateSpeed={0.6}
  minPolarAngle={Math.PI / 4}
  maxPolarAngle={Math.PI * 0.75}
/>

          
        
      </Suspense>
    </Canvas>
  );
};

export default ProductCanvas;
